import axios from 'axios'
import { BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcoesFiltrosEmissoesMdfe(empresaId) {
  const url = `${URL}/emissao-mdfe/opcoes-filtro/${empresaId}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE,
        payload: response
      })
  );
}
